import React from "react";
import clsx from "clsx";
import Container from "../views/Container";
import Item from "./Item";

import styles from "./Teasergroup2columns.styles";

const Teasergroup2columns = ({ elements }) => {
	const css = styles();

	const headline = elements.textcontent.items.find(element => element.name === "valHeadline")?.text
	const leftLinkValue = elements.textcontent.items.find(element => element.name === "valLeftLinkValue")?.text
	const rightLinkValue = elements.textcontent.items.find(element => element.name === "valRightLinkValue")?.text
	const leftLinkDisplay = elements.textcontent.items.find(element => element.name === "valLeftLinkDisplay")?.text
	const rightLinkDisplay = elements.textcontent.items.find(element => element.name === "valRightLinkDisplay")?.text
	const leftImage = elements.elements.find(element => element.tag === "labLeftImage")?.media[0]
	const rightImage = elements.elements.find(element => element.tag === "labRightImage")?.media[0]

	return (
		<div className={clsx(css.teasergroup2columns, "mco-extension-component-teasergroup2columns")}>
			<Container
				className={clsx(css.container, "mco-extension-component-teasergroup2columns__container")}
			>
				{headline &&
					<h2 className={clsx(css.headline, "mco-extension-component-teasergroup2columns__headline")}>{headline}</h2>
				}
				<Item linkvalue={leftLinkValue} linkdisplay={leftLinkDisplay} itemImage={leftImage} />
				<Item linkvalue={rightLinkValue} linkdisplay={rightLinkDisplay} itemImage={rightImage} />
			</Container>
		</div>
	);
};

export default Teasergroup2columns;
